import React, { FC, useState } from "react";
import { PROGRESS_API_PATH, RESOURCES_UI_PATH, useEffectOnce } from "./Constants";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { AckErrorMessage, AckLoader, useFetch } from "ackbox-weblib-react";

export type ProgressData = {
  hasAccount: boolean;
  hasCategory: boolean;
  hasTransaction: boolean;
  isComplete: boolean;
}

export const useProgress = () => {
  const [hasData, setData] = useState({} as ProgressData);
  const ackFetch = useFetch(PROGRESS_API_PATH);

  const { errors, isLoading } = useEffectOnce(async () => {
    const values = await ackFetch.get("all/");
    setData(values);
  });

  return { ...hasData, errors, isLoading };
};

export type ProgressProps = {
  hasAccount: boolean;
  hasCategory: boolean;
  hasTransaction: boolean;
  isComplete: boolean;
  errors: string[];
  isLoading: boolean;
}

export const Progress: FC<ProgressProps> = (props) => {
  const Marker: FC<{ isComplete: boolean }> = (props) => {
    const incompleteMarkerClass = "timeline-marker is-icon is-32x32";
    const completeMarkerClass = `${incompleteMarkerClass} is-primary`;
    return (
      <div className={props.isComplete ? completeMarkerClass : incompleteMarkerClass}>
        <FontAwesomeIcon icon="check" color="white" size="xs"/>
      </div>
    );
  };

  const Body = () => {
    return (
      <>
        <h2 className="subtitle">We are almost there! Complete the following steps to start.</h2>
        <div className="timeline mb-4">
          <div className="timeline-item">
            <Marker isComplete={props.hasAccount}/>
            <div className="timeline-content">
              <p className="heading">Create your first account</p>
              <p>Access the <a href={`${RESOURCES_UI_PATH}/accounts`}>accounts</a> page and create an account</p>
            </div>
          </div>
          <div className="timeline-item">
            <Marker isComplete={props.hasCategory}/>
            <div className="timeline-content">
              <p className="heading">Create your first expense/income category</p>
              <p>Access the <a href={`${RESOURCES_UI_PATH}/categories`}>categories</a> page and create a category</p>
            </div>
          </div>
          <div className="timeline-item">
            <Marker isComplete={props.hasTransaction}/>
            <div className="timeline-content">
              <p className="heading">Create your first expense/income</p>
              <p>Access the <a href={`${RESOURCES_UI_PATH}/incomes`}>incomes</a><span> or </span>
                <a href={`${RESOURCES_UI_PATH}/expenses`}>expenses</a> page and create a transaction</p>
            </div>
          </div>
        </div>
      </>
    );
  };

  return (
    <>
      {props.errors.length > 0 && <AckErrorMessage errors={props.errors}/>}
      <AckLoader isLoading={props.isLoading}/>
      {!props.isLoading && !props.isComplete && <Body/>}
    </>
  );
};
